angular.module('billing').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/billing/views/billing.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-primary\">\r" +
    "\n" +
    "        <div class=\"panel-body panel-flush\" ng-class=\"(modalPrint)?'hidden-print':''\">\r" +
    "\n" +
    "            <div class=\"panel-subheading-messages\">\r" +
    "\n" +
    "                <span>{{::'This information is associated to you (' + loginUser.fullName + ') as a responsible party.' | translate}}</span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"viewMakeAPaymentFeature\">\r" +
    "\n" +
    "                <div class=\"panel-subheading\" >\r" +
    "\n" +
    "                    <span >{{::'Total Responsible Party Balance' | translate}}</span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"text-center\" ng-if=\"loadingBillingAccount\">\r" +
    "\n" +
    "                    <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div ng-if=\"!loadingBillingAccount\">\r" +
    "\n" +
    "                    <div class=\"row panel-row-no-border-bottom\">\r" +
    "\n" +
    "                        <div class=\"col-xs-6 col-md-4 col-flush\">\r" +
    "\n" +
    "                            <div class=\"large-description\">\r" +
    "\n" +
    "                                <ap-date-formatter date=\"{{model.Date}}\" format=\"long-abb-date\"></ap-date-formatter>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-6 col-md-4 col-flush text-center\">\r" +
    "\n" +
    "                            <div class=\"large-description\">\r" +
    "\n" +
    "                                {{::'Total Responsible Party Balance' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"large-date\">\r" +
    "\n" +
    "                                {{::model.PersonBalanceAll | currency}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-md-4 col-flush\" ng-if=\"!model.DepositByFinancialCenterEnabled\">\r" +
    "\n" +
    "                            <div class=\"align-right\">\r" +
    "\n" +
    "                                <div>\r" +
    "\n" +
    "                                    <button class=\"btn btn-primary\" ng-click=\"makeGenericOnlinePayment()\">\r" +
    "\n" +
    "                                        {{::'Make Online Payment' | translate}}\r" +
    "\n" +
    "                                    </button>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"body-text\" ng-show=\"model.ConsentAnnual.CardType\">\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        {{::'You have a card on file:' | translate}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        {{model.ConsentAnnual.CardType}}&nbsp;{{model.ConsentAnnual.ExpDate}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div ng-if=\"model.DepositByFinancialCenterEnabled\">\r" +
    "\n" +
    "                        <div class=\"row panel-row\">\r" +
    "\n" +
    "                            <div class=\"col-xs-6 col-md-4 col-flush\">\r" +
    "\n" +
    "                                <div class=\"large-description\">\r" +
    "\n" +
    "                                    Financial Centers\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-6 col-md-4 text-center\">\r" +
    "\n" +
    "                                <div class=\"large-description\">\r" +
    "\n" +
    "                                    Statement Balances\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"row panel-row-no-border-bottom\" ng-repeat=\"balance in model.FinancialCenterBalances\">\r" +
    "\n" +
    "                            <div class=\"col-xs-6 col-md-4 col-flush\">\r" +
    "\n" +
    "                                <div class=\"large-description\">\r" +
    "\n" +
    "                                    {{balance.FinancialCenterName}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-6 col-md-4 text-center\">\r" +
    "\n" +
    "                                <div class=\"large-description\">\r" +
    "\n" +
    "                                    {{balance.Balance | currency}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-12 col-md-4 col-flush\">\r" +
    "\n" +
    "                                <div class=\"align-right\">\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        <button class=\"btn btn-primary\" ng-click=\"makeSpecificOnlinePayment({{balance}})\">\r" +
    "\n" +
    "                                            {{::'Make Online Payment' | translate}}\r" +
    "\n" +
    "                                        </button>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"body-text\" ng-show=\"model.ConsentAnnual.CardType\">\r" +
    "\n" +
    "                                        <div>\r" +
    "\n" +
    "                                            {{::'You have a card on file:' | translate}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div>\r" +
    "\n" +
    "                                            {{model.ConsentAnnual.CardType}}&nbsp;{{model.ConsentAnnual.ExpDate}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"viewMakeAPaymentFeature\">\r" +
    "\n" +
    "                <div class=\"panel-subheading panel-no-pending-appointments-subheading\">\r" +
    "\n" +
    "                    {{::'Pending Payments' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12\">\r" +
    "\n" +
    "                        <div ng-if=\"loadingPaymentHistory\">\r" +
    "\n" +
    "                            <div class=\"text-center\" ng-if=\"loadingPaymentHistory\">\r" +
    "\n" +
    "                                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div ng-if=\"!loadingPaymentHistory\">\r" +
    "\n" +
    "                            <div class=\"body-text\" ng-if=\"!model.PaymentHistory.length\">\r" +
    "\n" +
    "                                {{'No pending payments' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"panel-list-padding\">\r" +
    "\n" +
    "                                <div ng-repeat=\"payment in model.PaymentHistory\" class=\"row panel-row\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-10 col-xs-flush\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-6 col-md-8 col-flush\">\r" +
    "\n" +
    "                                            <div class=\"col-xs-12 col-xs-flush col-md-5\">\r" +
    "\n" +
    "                                                <div>\r" +
    "\n" +
    "                                                    <ap-date-formatter date=\"{{::payment.Date}}\"\r" +
    "\n" +
    "                                                                       format=\"short-date\"></ap-date-formatter>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div class=\"col-xs-12 col-xs-flush col-md-7 text-center\">\r" +
    "\n" +
    "                                                <div>\r" +
    "\n" +
    "                                                    {{::payment.LastName}},&nbsp;{{::payment.FirstName}}\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div>\r" +
    "\n" +
    "                                                    {{::payment.SourceOfPayment}}\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"col-xs-6 col-md-4 col-flush text-center\">\r" +
    "\n" +
    "                                            {{::payment.Amount | currency}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-2 col-xs-flush\">\r" +
    "\n" +
    "                                        <button class=\"btn btn-default1 pull-right\" ng-click=\"viewReceipt(payment.TxId)\">\r" +
    "\n" +
    "                                            {{::'View' | translate}}\r" +
    "\n" +
    "                                        </button>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div ng-if=\"viewLedgerFeature || viewStatementFeature\">\r" +
    "\n" +
    "                <div class=\"panel-subheading\">\r" +
    "\n" +
    "                    {{::'Reports' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"row panel-row-no-border-bottom\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-flush text-center\">\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            <button class=\"btn btn-default1\" ng-if=\"viewLedgerFeature && ledgerAvailable\" ng-click=\"viewLedgerPdf()\">\r" +
    "\n" +
    "                                {{'View Ledger' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                            <span ng-if=\"!ledgerAvailable\">{{::'No ledger found' | translate}}</span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"viewStatementFeature\">\r" +
    "\n" +
    "                <div class=\"panel-subheading panel-no-pending-appointments-subheading\">\r" +
    "\n" +
    "                    {{::'Statement History' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12\">\r" +
    "\n" +
    "                        <div ng-if=\"loadingStatementHistory\">\r" +
    "\n" +
    "                            <div class=\"text-center\" ng-if=\"loadingStatementHistory\">\r" +
    "\n" +
    "                                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div ng-if=\"!loadingStatementHistory\">\r" +
    "\n" +
    "                            <div class=\"body-text\" ng-if=\"!model.StatementHistory.length\">\r" +
    "\n" +
    "                                {{'No statements found' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div ng-repeat=\"statement in model.StatementHistory\" class=\"row panel-row\">\r" +
    "\n" +
    "                                <div class=\"col-md-3 col-xs-2 col-flush\">\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        <ap-date-formatter date=\"{{::statement.Date}}\"\r" +
    "\n" +
    "                                                           format=\"short-date\"></ap-date-formatter>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-md-3 col-xs-3 col-flush\">\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        {{::statement.FinancialCenterName}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-md-2 col-xs-2 col-flush text-center\">\r" +
    "\n" +
    "                                    {{::statement.Balance | currency}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-md-3 col-xs-4 col-flush\">\r" +
    "\n" +
    "                                    <div class=\"text-center\">\r" +
    "\n" +
    "                                        <div class=\"row\" ng-show=\"statement.IsViewable\">\r" +
    "\n" +
    "                                            <span>\r" +
    "\n" +
    "                                                <i class=\"fa fa-file fa-lg\"></i>&nbsp;\r" +
    "\n" +
    "                                                    <a ng-click=\"viewStatementHistoryItem(statement)\"><u>{{::'View Statement' | translate}}</u></a>\r" +
    "\n" +
    "                                            </span>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div ng-show=\"!statement.IsViewable\">\r" +
    "\n" +
    "                                            {{::'Unavailable' | translate}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-md-1 col-xs-1 col-flush\">\r" +
    "\n" +
    "                                    <div class=\"pull-right\">\r" +
    "\n" +
    "                                        <button ap-save-to-file=\"downloadStatementHistoryItem(statement)\"\r" +
    "\n" +
    "                                                ><i ng-show=\"!statement.Downloading\" class=\"fa fa-download\"></i><ap-spinner ng-show=\"statement.Downloading\"></ap-spinner></button>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient billing could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{::'You do not have access to this patient\\'s billing.'| translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/billing/views/modals/confirmPaymentModal.html',
    "<div class=\"modal-content\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <h4 class=\"modal-title\">{{::'Payment Summary' | translate}}</h4>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6 text-center\">\r" +
    "\n" +
    "                <label>{{'Card Type' | translate}}</label>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <p>{{consentAnnual.CardType}}</p>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6 text-center\">\r" +
    "\n" +
    "                <label>{{'Mask' | translate}}</label>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <p>{{consentAnnual.Mask}}</p>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6 text-center\">\r" +
    "\n" +
    "                <label>{{'Exp Date' | translate}}</label>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <p>{{consentAnnual.ExpDate}}</p>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6 text-center\">\r" +
    "\n" +
    "                <label>{{'Amount' | translate}}</label>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <p>{{chargeAmount | currency}}</p>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                <button type=\"button\" class=\"btn btn-default btn-lg pull-left\" ng-click=\"cancel()\">{{::'Close' | translate}}</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                <button\r" +
    "\n" +
    "                        class=\"btn btn-primary btn-lg pull-right\"\r" +
    "\n" +
    "                        ng-disabled=\"sending\"\r" +
    "\n" +
    "                        ng-click=\"accept()\">\r" +
    "\n" +
    "                    {{::'Submit Payment' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/billing/views/modals/ledgerModal.html',
    "<div class=\"modal-dialog-report\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{'Ledger' | translate}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div ng-if=\"loadingLedger\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loadingLedger\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!loadingLedger\">\r" +
    "\n" +
    "            <iframe ng-src=\"{{model.LedgerData}}\">\r" +
    "\n" +
    "            </iframe>\r" +
    "\n" +
    "            <div class=\"text-center\">\r" +
    "\n" +
    "            <span>{{'Unable to view? Download ' | translate}}<a\r" +
    "\n" +
    "                    ap-save-pdf-to-file=\"{{model.ByteArray}}\"\r" +
    "\n" +
    "                    file-name=\"{{model.PdfFileName}}\"\r" +
    "\n" +
    "                    content-type=\"{{model.ContentType}}\">{{'here.' | translate}}</a></span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"ok()\">{{::'Close' | translate}}</button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/billing/views/modals/receiptModal.html',
    "<div class=\"modal-dialog modal-dialog-print\">\r" +
    "\n" +
    "    <div class=\"modal-body\" ng-if=\"!loadingReceipt\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <div class=\"receipt-margin\" ng-bind-html=\"model.ReceiptHtml\"></div>\r" +
    "\n" +
    "        <div ng-show=\"!model.ReceiptHtml\">{{'Error generating receipt.' | translate}}</div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loadingReceipt\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-show=\"loadingReceipt\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-footer hidden-print\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                <button type=\"button\" class=\"btn btn-default1 btn-lg pull-left\" ng-click=\"print()\">\r" +
    "\n" +
    "                    {{::'Print' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                <button type=\"button\" class=\"btn btn-default btn-lg pull-right\" ng-click=\"ok()\">\r" +
    "\n" +
    "                    {{::'Close' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/billing/views/modals/statementModal.html',
    "<div class=\"modal-dialog-report\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{'Statement' | translate}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div ng-if=\"loadingStatement\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loadingStatement\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!loadingStatement\">\r" +
    "\n" +
    "            <iframe ng-src=\"{{model.StatementData}}\">\r" +
    "\n" +
    "            </iframe>\r" +
    "\n" +
    "            <div class=\"text-center\">\r" +
    "\n" +
    "              <span>{{'Unable to view? Download ' | translate}}<a\r" +
    "\n" +
    "                      ap-save-pdf-to-file=\"{{model.ByteArray}}\"\r" +
    "\n" +
    "                      file-name=\"{{model.PdfFileName}}\"\r" +
    "\n" +
    "                      content-type=\"{{model.ContentType}}\">{{'here.' | translate}}</a></span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"ok()\">{{::'Close' | translate}}</button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/billing/views/partials/paymentFromConsent.html',
    "<form name=\"paymentFromConsentForm\" ng-submit=\"submit()\" novalidate>\r" +
    "\n" +
    "    <div ng-if=\"!loadingBillingAccount && !httpError\">\r" +
    "\n" +
    "        <div class=\"col-xs-12 col-md-8 col-flush-left\">\r" +
    "\n" +
    "            <div class=\"form-group\"\r" +
    "\n" +
    "                    ng-class=\"{ 'has-error' : (paymentFromConsentForm.ChargeAmount.$invalid\r" +
    "\n" +
    "                                                            && (paymentFromConsentForm.ChargeAmount.$dirty\r" +
    "\n" +
    "                                                                    || paymentFromConsentForm.isSubmitted))}\">\r" +
    "\n" +
    "                <label class=\"control-label\">{{::'Enter payment amount' | translate}}</label>\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                        id=\"ChargeAmount\"\r" +
    "\n" +
    "                        name=\"ChargeAmount\"\r" +
    "\n" +
    "                        ng-model=\"payment.ChargeAmount\"\r" +
    "\n" +
    "                        ng-pattern=\"chargeRegEx\"\r" +
    "\n" +
    "                        ng-required=\"true\"\r" +
    "\n" +
    "                        ng-max=\"maxPaymentAmount\"\r" +
    "\n" +
    "                        type=\"number\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-messages=\"paymentFromConsentForm.ChargeAmount.$error\"\r" +
    "\n" +
    "                        class=\"has-error\">\r" +
    "\n" +
    "                    <div ng-message=\"required\"></div>\r" +
    "\n" +
    "                    <div ng-message=\"pattern\">{{'Invalid amount' | translate}}</div>\r" +
    "\n" +
    "                    <div ng-message=\"max\">{{'Amount exceeds remaining amount or per charge limit' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "        <div class=\"col-xs-4 col-flush-left\">\r" +
    "\n" +
    "            <button\r" +
    "\n" +
    "                    id=\"cancel-btn\"\r" +
    "\n" +
    "                    class=\"btn btn-default2 btn-lg pull-left\"\r" +
    "\n" +
    "                    ng-disabled=\"sending\"\r" +
    "\n" +
    "                    data-transition-to=\"{appRoute: 'billing'}\">\r" +
    "\n" +
    "                {{::'Cancel' | translate}}\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-4\">\r" +
    "\n" +
    "            <button type=\"submit\" class=\"btn btn-primary btn-lg pull-right\"\r" +
    "\n" +
    "                    ng-disabled=\"sending\">\r" +
    "\n" +
    "                <span class=\"ng-hide\" ng-show=\"submitPaymentLoading\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                {{'Review Payment' | translate}}\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"!loadingBillingAccount\">\r" +
    "\n" +
    "        <ap-confirm-payment\r" +
    "\n" +
    "                post-method=\"postPayment\"\r" +
    "\n" +
    "                consent-annual=\"payment.ConsentAnnual\"\r" +
    "\n" +
    "                charge-amount=\"payment.ChargeAmount\"\r" +
    "\n" +
    "                ></ap-confirm-payment>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</form>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div ng-if=\"loadingBillingAccount || httpError\">\r" +
    "\n" +
    "    <div class=\"text-center\" ng-show=\"loadingBillingAccount\">\r" +
    "\n" +
    "        <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "        {{\"An error has occurred and make a payment could not be loaded.\" | translate}}\r" +
    "\n" +
    "    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "        {{\"You do not have access to make a payment online.\"| translate}}\r" +
    "\n" +
    "    </uib-alert>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/billing/views/partials/paymentFromNewCard.html',
    "<div ng-if=\"!loadingBillingAccount && !httpError\">\r" +
    "\n" +
    "    <form name=\"appointmentRequestForm\" novalidate>\r" +
    "\n" +
    "        <div class=\"col-xs-12 col-md-8 col-flush\">\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <label class=\"control-label\">{{::'Enter Payment Details' | translate}}</label>\r" +
    "\n" +
    "                <div ng-if=\"!loadingUrl\">\r" +
    "\n" +
    "                    <ap-payment-frame [url]=\"model.OneTimePaymentUrl\" (apply-payment)=\"redirectUrlPostBack($event)\"></ap-payment-frame>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div ng-if=\"loadingUrl\">\r" +
    "\n" +
    "                    <div class=\"text-center\" ng-show=\"loadingUrl\">\r" +
    "\n" +
    "                        <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </form>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div ng-if=\"loadingBillingAccount || httpError\">\r" +
    "\n" +
    "    <div class=\"text-center\" ng-show=\"loadingBillingAccount\"><ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "        {{\"An error has occurred and the page could not be loaded.\" | translate}}\r" +
    "\n" +
    "    </uib-alert>\r" +
    "\n" +
    "    <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "        {{\"You do not have access to this page.\"| translate}}\r" +
    "\n" +
    "    </uib-alert>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/billing/views/paymentOptions.html',
    "<div ng-cloak>\r" +
    "\n" +
    "\t<div class=\"panel panel-primary\">\r" +
    "\n" +
    "\t\t<div class=\"panel-heading-appointments panel-flush\">\r" +
    "\n" +
    "            {{::'Make A Payment' | translate}}\r" +
    "\n" +
    "\t\t</div>\r" +
    "\n" +
    "\t\t<div ng-if=\"!loadingBillingAccount && !httpError\">\r" +
    "\n" +
    "\t\t\t<div class=\"panel-body\">\r" +
    "\n" +
    "\t\t\t\t<div class=\"panel-subheading\">\r" +
    "\n" +
    "                    {{::'Statement' | translate}}&nbsp:&nbsp<ap-date-formatter date=\"{{model.Date}}\" format=\"long-abb-date\"/>\r" +
    "\n" +
    "\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t<div class=\"row panel-row-no-border-bottom\">\r" +
    "\n" +
    "\t\t\t\t\t<div class=\"col-xs-12 col-md-3 col-flush\">\r" +
    "\n" +
    "\t\t\t\t\t\t<div class=\"form-group\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t<label>{{::'Balance' | translate}}</label>\r" +
    "\n" +
    "\t\t\t\t\t\t\t<p class=\"large-date\">{{::model.PersonBalanceAll | currency}}</p>\r" +
    "\n" +
    "\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t<div class=\"col-xs-12 col-md-9 col-flush-left\">\r" +
    "\n" +
    "\t\t\t\t\t\t<div class=\"form-group\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t<label class=\"control-label\">{{::'Select payment method' | translate}}</label>\r" +
    "\n" +
    "\t\t\t\t\t\t\t<select class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\tname=\"PaymentMethod\"\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\tng-model=\"model.PaymentMethodSelect\"\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\tng-change=\"paymentMethodSelected()\"\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\tng-options=\"method.Name for method in PaymentMethodList\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t</select>\r" +
    "\n" +
    "\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t<div class=\"row panel-row-no-border-bottom\">\r" +
    "\n" +
    "\t\t\t\t\t<div class=\"col-xs-12 col-md-4 col-flush-left\">\r" +
    "\n" +
    "\t\t\t\t\t\t<div ng-if=\"viewMakeAPaymentFeature\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t<div class=\"panel-subheading panel-no-pending-appointments-subheading\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t{{::'Pending Payments' | translate}}\r" +
    "\n" +
    "\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t<div ng-if=\"loadingPaymentHistory\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t<div class=\"text-center\" ng-if=\"loadingPaymentHistory\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t<ap-spinner size=\"3\"/>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t<div ng-if=\"!loadingPaymentHistory\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t<div class=\"body-text\" ng-if=\"!model.PaymentHistory.length\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t{{'No pending payments' | translate}}\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t<div class=\"panel-list-padding\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t<div ng-repeat=\"payment in model.PaymentHistory\" class=\"row panel-row\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t<div class=\"col-xs-flush\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-flush\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-xs-flush\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ap-date-formatter date=\"{{::payment.Date}}\" format=\"short-date\"/>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-xs-flush text-center\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{::payment.LastName}},&nbsp;{{::payment.FirstName}}\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{::payment.SourceOfPayment}}\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-xs-flush text-center\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t{{::payment.Amount | currency}}\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t\t<div class=\"container-fluid container-flush\" ui-view>\r" +
    "\n" +
    "\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t</div>\r" +
    "\n" +
    "\t\t</div>\r" +
    "\n" +
    "\t\t<div ng-if=\"loadingBillingAccount || httpError\">\r" +
    "\n" +
    "\t\t\t<div class=\"text-center\" ng-show=\"loadingBillingAccount\">\r" +
    "\n" +
    "\t\t\t\t<ap-spinner size=\"3\"/>\r" +
    "\n" +
    "\t\t\t</div>\r" +
    "\n" +
    "\t\t\t<uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{\"An error has occurred and billing could not be loaded.\" | translate}}\r" +
    "\n" +
    "\t\t\t</uib-alert>\r" +
    "\n" +
    "\t\t\t<uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "        {{\"You do not have access to billing.\"| translate}}\r" +
    "\n" +
    "\t\t\t</uib-alert>\r" +
    "\n" +
    "\t\t</div>\r" +
    "\n" +
    "\t</div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/billing/views/paymentStatementsOnly.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div id=\"form-results-panel\" class=\"panel panel-primary\" ng-class=\"(isModalDisplayed) ? 'hidden-print' : ''\">\r" +
    "\n" +
    "        <h1 class=\"large-description-40 text-center\"> {{::'Statements' | translate}}</h1>\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-md-12 col-flush pull-right\">\r" +
    "\n" +
    "                    <div class=\"align-right\">\r" +
    "\n" +
    "                        <div class=\"body-text\" ng-show=\"model.ConsentAnnual.CardType\">\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                {{::'You have a card on file:' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                {{model.ConsentAnnual.CardType}}&nbsp;{{model.ConsentAnnual.ExpDate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"viewMakeAPaymentFeature\">\r" +
    "\n" +
    "                <div class=\"panel-subheading panel-no-pending-appointments-subheading padding-top large\">\r" +
    "\n" +
    "                    <h1 class=\"large-description  center-text-small ng-binding\">\r" +
    "\n" +
    "                        <span ng-if=\"model.DepositByFinancialCenterEnabled\">{{::'Balances' | translate}}</span>\r" +
    "\n" +
    "                        <span ng-if=\"!model.DepositByFinancialCenterEnabled\">{{::'Total Balance' | translate}}</span>\r" +
    "\n" +
    "                    </h1>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"row\" ng-if=\"!model.DepositByFinancialCenterEnabled\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12\">\r" +
    "\n" +
    "                        <div ng-if=\"loadingPaymentHistory\">\r" +
    "\n" +
    "                            <div class=\"text-center\" ng-if=\"loadingPaymentHistory\">\r" +
    "\n" +
    "                                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div ng-if=\"!loadingBillingAccount\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 col-md-12 center-text center-text small\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-md-6 col-flush text-center\">\r" +
    "\n" +
    "                                    <div class=\"large-date\">\r" +
    "\n" +
    "                                        {{::model.PersonBalanceAll | currency}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-md-6 center-text small\">\r" +
    "\n" +
    "                                    <button class=\"btn btn-primary btn-lg btn-minpadding ap-margin-top-15\" ng-click=\"makeGenericOnlinePayment()\">\r" +
    "\n" +
    "                                        {{::'Make Online Payment' | translate}}\r" +
    "\n" +
    "                                    </button>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"row\" ng-if=\"model.DepositByFinancialCenterEnabled\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12\">\r" +
    "\n" +
    "                        <div ng-if=\"loadingPaymentHistory\">\r" +
    "\n" +
    "                            <div class=\"text-center\" ng-if=\"loadingPaymentHistory\">\r" +
    "\n" +
    "                                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div ng-if=\"!loadingBillingAccount\">\r" +
    "\n" +
    "                            <div class=\"row panel-row-no-border-bottom\" ng-repeat=\"balance in model.FinancialCenterBalances\">\r" +
    "\n" +
    "                                <div class=\"col-xs-6 col-md-4 col-flush\">\r" +
    "\n" +
    "                                    <div class=\"large-description\">{{balance.FinancialCenterName}}</div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-6 col-md-4 text-center\">\r" +
    "\n" +
    "                                    <div class=\"large-description\">{{balance.Balance | currency}}</div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-md-4 col-flush\">\r" +
    "\n" +
    "                                    <div class=\"align-right\">\r" +
    "\n" +
    "                                        <div>\r" +
    "\n" +
    "                                            <button class=\"btn btn-primary\" ng-click=\"makeSpecificOnlinePayment({{balance}})\">{{::'Make Online Payment' | translate}}</button>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"body-text\" ng-show=\"model.ConsentAnnual.CardType\">\r" +
    "\n" +
    "                                            <div>{{::'You have a card on file:' | translate}}</div>\r" +
    "\n" +
    "                                            <div>{{model.ConsentAnnual.CardType}}&nbsp;{{model.ConsentAnnual.ExpDate}}</div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"panel-subheading panel-no-pending-appointments-subheading padding-top large\">\r" +
    "\n" +
    "                    <h1 class=\"large-description center-text-small ng-binding\">{{::'Pending Payments' | translate}}</h1>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12\">\r" +
    "\n" +
    "                        <div ng-if=\"loadingPaymentHistory\">\r" +
    "\n" +
    "                            <div class=\"text-center\" ng-if=\"loadingPaymentHistory\">\r" +
    "\n" +
    "                                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div ng-if=\"!loadingPaymentHistory\">\r" +
    "\n" +
    "                            <div class=\"large-body-description center-text-small\" ng-if=\"!model.PaymentHistory.length\">\r" +
    "\n" +
    "                                {{'No pending payments' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div ng-repeat=\"payment in model.PaymentHistory\" class=\"row panel-row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-md-2 center-text center-text small col-flush large-body-description\">\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        <ap-date-formatter date=\"{{::payment.Date}}\" format=\"short-date\"></ap-date-formatter>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-md-5 col-flush text-center large-body-description\">\r" +
    "\n" +
    "                                    <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                        {{::payment.LastName}},&nbsp;{{::payment.FirstName}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        {{::payment.SourceOfPayment}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-md-2 col-flush large-body-description text-center\">\r" +
    "\n" +
    "                                    {{::payment.Amount | currency}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-md-2 col-xs-flush\">\r" +
    "\n" +
    "                                    <div class=\"text-center\">\r" +
    "\n" +
    "                                        <button class=\"btn btn-lg btn-primary btn-minpadding\" ng-click=\"viewReceipt(payment.TxId)\">\r" +
    "\n" +
    "                                            {{::'View Receipt' | translate}}\r" +
    "\n" +
    "                                        </button>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"viewStatementFeature\">\r" +
    "\n" +
    "                <div class=\"panel-subheading panel-no-pending-appointments-subheading padding-top large\">\r" +
    "\n" +
    "                    <h1 class=\"large-description  center-text-small\"> {{::'Statement History' | translate}}</h1>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 padding-top large\">\r" +
    "\n" +
    "                        <div ng-if=\"loadingStatementHistory\">\r" +
    "\n" +
    "                            <div class=\"text-center\" ng-if=\"loadingStatementHistory\">\r" +
    "\n" +
    "                                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div ng-if=\"!loadingStatementHistory\">\r" +
    "\n" +
    "                            <div class=\"large-description center-text\" ng-if=\"!model.StatementHistory.length\">\r" +
    "\n" +
    "                                {{'No statements found' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div ng-repeat=\"statement in model.StatementHistory\" class=\"row panel-row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-md-2 center-text center-text-small col-flush large-body-description\">\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        <ap-date-formatter date=\"{{::statement.Date}}\"\r" +
    "\n" +
    "                                                           format=\"short-date\"></ap-date-formatter>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-if=\"model.DepositByFinancialCenterEnabled\">\r" +
    "\n" +
    "                                    <div ng-if=\"statement.FinancialCenterName\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-12 col-md-3 col-flush text-center large-body-description\">\r" +
    "\n" +
    "                                            {{::statement.FinancialCenterName}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div ng-if=\"!statement.FinancialCenterName\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-12 col-md-3 col-flush text-center \">\r" +
    "\n" +
    "                                            {{'Unavailable' | translate}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-md-2 col-flush center-text center-text-small large-body-description\">\r" +
    "\n" +
    "                                    {{::statement.Balance | currency}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-show=\"statement.IsViewable\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-md-2\">\r" +
    "\n" +
    "                                        <div class=\"text-center\">\r" +
    "\n" +
    "                                            <button class=\"btn btn-lg btn-primary btn-minpadding\" ng-click=\"viewStatementHistoryItem(statement)\">\r" +
    "\n" +
    "                                                {{::'View Statement' | translate}}\r" +
    "\n" +
    "                                            </button>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-md-3\">\r" +
    "\n" +
    "                                            <button class=\"btn btn-lg btn-primary btn-minpadding\" ap-save-to-file=\"downloadStatementHistoryItem(statement)\" ng-hide=\"statement.Downloading\">{{::'Download Statement' | translate }}</button>\r" +
    "\n" +
    "                                            <div ng-show=\"!statement.Downloading\"></div><ap-spinner ng-show=\"statement.Downloading\"></ap-spinner>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div>\r" +
    "\n" +
    "                <button class=\"btn btn-default2 btn-lg ap-margin-top-15 .ap-margin-bottom-10 clickable\" ng-click=\"logOff()\">\r" +
    "\n" +
    "                    {{::'Sign Out' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/billing/views/paymentSummary.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-primary\">\r" +
    "\n" +
    "        <div class = \"hidden-print\">\r" +
    "\n" +
    "        <div class=\"panel-heading-appointments panel-flush\">\r" +
    "\n" +
    "            {{::'Your payment has been submitted.' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"text-center\">\r" +
    "\n" +
    "            {{:: 'Your pending payments can be viewed from the main Billing page.' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "            <div class=\"panel-body\">\r" +
    "\n" +
    "                <div class=\"row panel-row-no-border-bottom\">\r" +
    "\n" +
    "                    <div class=\"col-xs-3\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-12 ap-confirm-content-area\">\r" +
    "\n" +
    "                        <div class=\"receipt-padding\" ng-bind-html=\"model.ReceiptHtml\"></div>\r" +
    "\n" +
    "                        <div class=\"hidden-print\">\r" +
    "\n" +
    "                            <button\r" +
    "\n" +
    "                                    class=\"btn btn-primary pull-right\"\r" +
    "\n" +
    "                                    ng-click=\"done()\">\r" +
    "\n" +
    "                                {{::'Done' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                            <button\r" +
    "\n" +
    "                                    class=\"btn \"\r" +
    "\n" +
    "                                    ng-click=\"print()\">\r" +
    "\n" +
    "                                {{::'Print' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-3\"></div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the confirmation page could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{::'You do not have access to this patient\\'s appointments.'| translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/billing/views/transactionComplete.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-primary\">\r" +
    "\n" +
    "        <div class=\"panel-heading-appointments\">\r" +
    "\n" +
    "            {{::'Transaction Complete' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"text-center\">\r" +
    "\n" +
    "            <p>{{'You will be redirected shortly...'| translate}}</p>\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );

}]);
